import {
    GET_TICKETS_REQUEST,
    GET_TICKETS_SUCCESS,
    GET_TICKETS_FAILURE,
    GET_TICKET_REQUEST,
    GET_TICKET_SUCCESS,
    GET_TICKET_FAILURE,
    SUBMIT_TICKETS_REQUEST,
    SUBMIT_TICKETS_SUCCESS,
    SUBMIT_TICKETS_FAILURE,
    SET_TICKETS,
    SET_TICKET,
    SET_SUBMIT_TICKET_SUCCESS,
    SET_SUBMIT_TICKET_FETCHING,
    GET_EXPORT_FAILURE,
    GET_EXPORT_SUCCES,
    GET_EXPORT_REQUEST,
    GET_COMPANY_PLANS_REQUEST,
    GET_COMPANY_PLANS_SUCCESS,
    GET_COMPANY_PLANS_FAILURE,
    GET_NON_INSTALLATION_REASONS_REQUEST,
    GET_NON_INSTALLATION_REASONS_SUCCESS,
    GET_NON_INSTALLATION_REASONS_FAILURE
} from '../actions/tickets';
import { buildTickets, buildTicket } from '../helpers/tickets';

const initialState = {
    fetching: false,
    submitFetching: false,
    submitSuccess: false,
    eventFetching: false,
    tickets: [],
    ticket: {},
    total: 0,
    exportFetching:false,
    exportId:[],
    companyPlansFetching:false,
    companyPlans:[],
    nonInstallationReasonsFetching: false,
    nonInstallationReasons: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_EXPORT_REQUEST:{
            return{
                ...state,
                exportFetching:true
            };
        }
        case GET_EXPORT_SUCCES:{
            return{
                ...state,
                exportFetching:false,
                exportId:[...state.exportId, action.payload.exportId]
            };
        }
        case GET_EXPORT_FAILURE:{
            return{
                ...state,
                exportFetching:false
            };
        }
        case GET_TICKETS_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_TICKETS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                tickets: state.tickets.concat(buildTickets(action.payload.tickets, action.payload.type)),
                total:
                    (!action.payload.total || action.payload.total === 0) ? state.total : action.payload.total
            };
        }
        case GET_TICKETS_FAILURE: {
            return {
                ...state,
                fetching: false,
                tickets: state.tickets || []
            };
        }
        case GET_TICKET_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_TICKET_SUCCESS: {
            return {
                ...state,
                fetching: false,
                ticket: buildTicket(action.payload.ticket, action.payload.type)
            };
        }
        case GET_TICKET_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_COMPANY_PLANS_REQUEST:{
            return{
                ...state,
                companyPlansFetching:true
            };
        }
        case GET_COMPANY_PLANS_SUCCESS:{
            return{
                ...state,
                companyPlansFetching:false,
                companyPlans: action.payload,

            };
        }
        case GET_COMPANY_PLANS_FAILURE:{
            return{
                ...state,
                companyPlansFetching:false
            };
        }
        case GET_NON_INSTALLATION_REASONS_REQUEST:{
            return{
                ...state,
                nonInstallationReasonsFetching: true
            };
        }
        case GET_NON_INSTALLATION_REASONS_SUCCESS:{
            return{
                ...state,
                nonInstallationReasonsFetching: false,
                nonInstallationReasons: action.payload.reasons
            };
        }
        case GET_NON_INSTALLATION_REASONS_FAILURE:{
            return{
                ...state,
                nonInstallationReasonsFetching: false
            };
        }
        case SUBMIT_TICKETS_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false,
                eventFetching: true
            };
        }
        case SUBMIT_TICKETS_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true,
                eventFetching: false,
                ticket: { ...action.payload.ticket }
            };
        }
        case SUBMIT_TICKETS_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                eventFetching: false
            };
        }
        case SET_TICKETS: {
            return {
                ...state,
                tickets: action.payload.tickets,
                total: action.payload.total
            };
        }
        case SET_TICKET: {
            return {
                ...state,
                ticket: action.payload.ticket
            };
        }
        case SET_SUBMIT_TICKET_SUCCESS: {
            return {
                ...state,
                submitSuccess: action.payload.success
            }
        }
        case SET_SUBMIT_TICKET_FETCHING: {
            return {
                ...state,
                submitFetching: action.payload.submitFetching,
                eventFetching: action.payload.eventFetching
            }
        }
        default:
            return state;
    }
};
